import React, { useState } from 'react';
import { Field } from 'react-final-form'
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import fr from 'react-phone-number-input/locale/fr';
import { formatPhoneNumber } from 'react-phone-number-input';

import './PhoneField.css';

const PhoneField = ({ name, options, placeholder, onPhoneChange, defaultValue, ...rest }) => {
    const [needsFocus, setNeedsFocus] = useState(false);

    const PhoneAdapter = ({input}) => {
        return <PhoneInput
            labels={fr}
            defaultCountry="FR"
            value={input.value}
            autoFocus={needsFocus}
            onFocus={() => setNeedsFocus(true)}
            onBlur={() => setNeedsFocus(false)}
            onChange={value => input.onChange(value)}
        />
    }

    return (
        <div className="PhoneField">
            <Field name={ name } component={ PhoneAdapter } />
        </div>
    );
}

export default PhoneField;
